"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoomPlayerAction = void 0;
var RoomPlayerAction;
(function (RoomPlayerAction) {
    RoomPlayerAction["None"] = "none";
    RoomPlayerAction["Blocked"] = "blocked";
    RoomPlayerAction["Uno"] = "uno";
    RoomPlayerAction["DrawTwo"] = "draw_two";
    RoomPlayerAction["DrawFour"] = "draw_four";
    RoomPlayerAction["ChoosingColor"] = "choosing_color";
    RoomPlayerAction["ChoosingSwapTarget"] = "choosing_swap_target";
    RoomPlayerAction["WantsSkipTurn"] = "wants_skip_turn";
    RoomPlayerAction["SkipTurn"] = "skip_turn";
})(RoomPlayerAction || (exports.RoomPlayerAction = RoomPlayerAction = {}));
